export default [
	{
		path: '',
		component: () => import('@/pages/Home/Home/Pages/Home'),
		name: 'Home',
		meta: {
			pai: 'Home',
			title: 'Admin - Home',
			navigation: [{
				pagina: 'Home',
				class: 'ace-icon fa fa-home home-icon',
				active: true,
				url: ''
			}],
			noCache: true
		}
	}
]